export default __webpack_public_path__ + "static/media/CV.4f9b2ae5.pdf";